import { ChangeEvent, FC, useState } from 'react';
import { Button, FloatingLabel, Form, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { IModal } from '../../props';
import { BlackListed } from '../../Services/worker';
import './funcModal.css';

const BlackListModalContent: FC<IModal> = ({ selectedBranch, title, setShowl, usersData }) => {
  const INITIAL_BLACKLISTING_STATE = {
    worker: '',
    branch: selectedBranch,
    comment: ''
  };

  const [black, setBlack] = useState(INITIAL_BLACKLISTING_STATE);
  const [requesting, setRequesting] = useState(false);

  const handleInputChange = (event: ChangeEvent<HTMLSelectElement> | ChangeEvent<any>) => {
    const { name, value } = event.target;
    setBlack((values) => ({ ...values, [name]: value }));
  };

  const BlacklistWorker = () => {
    setRequesting(true);
    const data = {
      worker: usersData?.id,
      branch: usersData?.branch,
      comment: black.comment
    };
    BlackListed(data)
      .then((response) => {
        setBlack({
          worker: `${usersData?.id}`,
          branch: response.data.branch,
          comment: response.data.comment
        });
        toast.success(`تم طلب ${title} ل${usersData?.name}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      })
      .catch((e: any) => {
        toast.error(`${e.response.data.detail[1]}`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined
        });
      })
      .finally(() => {
        setRequesting(false);
      });
  };

  const onClick = () => {
    BlacklistWorker();
    setShowl(false);
  };

  return (
    <>
      <div className="d-flex justify-content-between mt-3 me-2">
        <div style={{ width: '90%' }}>
          <FloatingLabel controlId="floatingTextarea2" label="تعليق">
            <Form.Control
              name="comment"
              value={black.comment}
              onChange={handleInputChange}
              as="textarea"
              style={{ height: '100px' }}
            />
          </FloatingLabel>
        </div>
      </div>
      <Button
        disabled={requesting}
        className="float-start mt-3"
        style={{ width: '20%' }}
        onClick={onClick}>
        {requesting ? (
          <div className="d-flex justify-content-center">
            <Spinner animation="border" variant="danger" />
          </div>
        ) : (
          <span>تأكيد</span>
        )}
      </Button>
    </>
  );
};

export default BlackListModalContent;
